import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";
import { padStart } from "@root/util/date";
import { range } from "lodash";

@Component({
  selector: "widget-schedule-on-a-specific-day",
  templateUrl: "./schedule-on-a-specific-day.component.html",
  styleUrls: ["./schedule-on-a-specific-day.component.scss"],
})
export class WidgetScheduleOnASpecificDayComponent implements OnInit {
  readonly listOfCycleOption = [
    { label: this.t.t("automation-message_rules_html_opt_every"), value: "every" },
    { label: this.t.t("automation-message_rules_html_opt_first"), value: "the_first" },
  ];

  readonly listOfWeekday = [1, 2, 3, 4, 5, 6, 7].map((i) => ({
    label: this.t.t("weekname.lang_day_" + i),
    value: i,
  }));

  readonly listOfCondition = [
    { label: this.t.t("automation-message_rules_html_opt_including"), value: "including" },
    { label: this.t.t("automation-message_rules_html_opt_excluding"), value: "excluding" },
  ];
  readonly listOfTimeOptions = range(0, 24).map((i) => ({
    label: `${padStart(i)}:00`,
    value: `${padStart(i)}:00`,
  }));

  @Input() value = {
    frequency: "every",
    day_of_week: 0,
    condition: "including",
  };
  @Input() at;

  @Output() valueChange = new EventEmitter();
  @Output() atChange = new EventEmitter();

  constructor(private t: TranslateService) {}

  ngOnInit() {}

  onValueChange() {
    this.valueChange.emit(this.value);
  }

  onAtChange() {
    this.atChange.emit(this.at);
  }
}
